export default {
    letters: {
        en: [
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z',
        ],
        ru: [
            'А',
            'Б',
            'В',
            'Г',
            'Д',
            'Е',
            'Ё',
            'Ж',
            'З',
            'И',
            'Й',
            'К',
            'Л',
            'М',
            'Н',
            'О',
            'П',
            'Р',
            'С',
            'Т',
            'У',
            'Ф',
            'Х',
            'Ц',
            'Ч',
            'Ш',
            'Щ',
            'Э',
            'Ю',
            'Я',
        ],
        uk: [
            'А',
            'Б',
            'В',
            'Г',
            'Д',
            'Е',
            'Є',
            'Ж',
            'З',
            'И',
            'Ї',
            'Й',
            'К',
            'Л',
            'М',
            'Н',
            'О',
            'П',
            'Р',
            'С',
            'Т',
            'У',
            'Ф',
            'Х',
            'Ц',
            'Ч',
            'Ш',
            'Щ',
            'Ю',
            'Я',
        ],
        lv: [
            'A',
            'Ā',
            'B',
            'C',
            'Č',
            'D',
            'E',
            'Ē',
            'F',
            'G',
            'Ģ',
            'H',
            'I',
            'Ī',
            'J',
            'K',
            'Ķ',
            'L',
            'Ļ',
            'M',
            'N',
            'Ņ',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'Š',
            'T',
            'U',
            'Ū',
            'V',
            'Z',
            'Ž',
        ],
        fr: [
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z',
        ],
        bg: [
            'А',
            'Б',
            'В',
            'Г',
            'Д',
            'Е',
            'Ж',
            'З',
            'И',
            'Й',
            'К',
            'Л',
            'М',
            'Н',
            'О',
            'П',
            'Р',
            'С',
            'Т',
            'У',
            'Ф',
            'Х',
            'Ц',
            'Ч',
            'Ш',
            'Щ',
            'Ю',
            'Я',
        ],
    },
    syllables: {
        en: [
            'AC',
            'BA',
            'FA',
            'RE',
            'KA',
            'LA',
            'JA',
            'MA',
            'ZE',
            'EZ',
            'KO',
            'LO',
            'GE',
            'FE',
            'IS',
            'SE',
            'LE',
            'PO',
            'MI',
            'MY',
            'YM',
            'YF',
            'XE',
            'EX',
            'VA',
            'OF',
        ],
        fr:[
            'AC',
            'BA',
            'FA',
            'RE',
            'KA',
            'LA',
            'JA',
            'MA',
            'ZE',
            'EZ',
            'KO',
            'LO',
            'GE',
            'FE',
            'IS',
            'SE',
            'LE',
            'PO',
            'MI',
            'MY',
            'YM',
            'YF',
            'XE',
            'EX',
            'VA',
            'OF',
        ],
        ru: [
            'АС',
            'ОФ',
            'ЕК',
            'ПЫ',
            'МИ',
            'ТИ',
            'ОР',
            'РО',
            'ЛО',
            'ОЛ',
            'ОЩ',
            'ЗИ',
            'УК',
            'УЦ',
            'ЯФ',
            'ВЯ',
            'БЕ',
            'РЕ',
            'ЕР',
            'ИС',
            'АП',
            'АЙ',
            'КА',
            'ДО',
            'ЗО',
            'ЗЕ',
            'ЩУ',
            'ШУ',
            'ГЕ',
            'ЫВ',
            'УВ',
            'УФ',
            'УН',
            'НУ',
            'ЭХ',
            'ХЭ',
            'ХЯ',
            'ХИ',
            'СИ',
            'ЧИ',
            'ЧЯ',
            'КЕ',
            'ДЕ',
            'ШЕ',
            'ПЕ',
            'ОГ',
            'ОП',
            'ОС',
        ],
        uk:[
            'ВА',
            'КА',
            'MO',
            'СЯ',
            'КО',
            'ЛО',
            'РЕ',
            'СО',
            'ТО',
            'ТУ',
            'ПI',
            'ГЕ',
            'ЛУ',
            'ЖИ',
            'ЛI',
            'ФИ',
            'ЗА',
            'ЩО',
            'ДO',
            'ЧИ',
            'ЛЕ',
            'ТА',
            'ДЕ',
            'ТИ',
            'ГО',
            'НА',
            'СУ',
        ],
        lv:[
            'VA',
            'LO',
            'DA',
            'LA',
            'KI',
            'BU',
            'MA',
            'NI',
            'TE',
            'VI',
            'PA',
            'KA',
            'MI',
            'TĪ',
            'SU',
            'NU',
            'KU',
            'ZU',
            'GA',
            'TĀ',
            'RU',
            'SI',
            'MU',
            'NO',
        ],
        bg:['PO',
            'ДO',
            'ДЕ',
            'ВЕ',
            'РА',
            'СИ',
            'ГО',
            'ДА',
            'РЯ',
            'ЛЕ',
            'КА',
            'ДЯ',
            'СЕ',
            'ХУ',
            'ЧЕ',
            'ЩЕ',
            'ВИ',
            'МИ',
            'КО',
            'ДИ',
            'НИ',
            'ЛА',
            'МО',
            'НЕ',
            'ТО',
            'ВА',
        ],
    },
};
